import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { media } from '../../../styles/style-utils';

import Section from '../../common/Section';
import MediaGrid from '../../common/MediaGrid';
import TextBlockWithIcon from '../textBlock/TextBlockWithIcon';
import Anchor from '../utils/Anchor';
import { get } from 'lodash';
import { getArtworkUrl, getArtworkDimensions } from '../utils/Contentful';
import { getBackgroundImage } from '../heroBlock/Hero';

const Wrapper = styled(Section)`
  padding-left: ${props => props.paddingLeft || 0};
  padding-right: ${props => props.paddingRight || 0};
  padding-top: ${props => props.paddingTop || 'var(--default-vertical-padding)'};
  padding-bottom: ${props => props.paddingBottom || 'var(--default-vertical-padding)'};
  background-color: ${props => props.backgroundColor || 'inherit'};
  background-image: ${props =>
    props.imgMobile ? `url(${getArtworkUrl(props.imgMobile)})` : getBackgroundImage(props)};
  background-position: ${props => props.bgPosition || 50}%;
  background-repeat: no-repeat;
  background-size: cover;

  ${media.large`
    background-image: ${props => getBackgroundImage(props)};
  `}

  .mediaText {
    padding-right: var(--default-horizontal-padding);
    padding-left: var(--default-horizontal-padding);
  }

  .mediaGrid {
    padding-right: ${props =>
      props.disableArtworkPadding ? 0 : 'var(--default-horizontal-padding)'};
    padding-left: ${props =>
      props.disableArtworkPadding ? 0 : 'var(--default-horizontal-padding)'};

    ${media.large`
      padding-right: ${props => (props.order === 1 && !props.disableArtworkPadding ? 'var(--default-horizontal-padding)' : 0)};
      padding-left: ${props => (props.order === 2 && !props.disableArtworkPadding ? 'var(--default-horizontal-padding)' : 0)};
    `}
  }
`;

const TwoColumnsBlock = ({ content }) => {
  const { artworkLarge, artworkSmall, artworkMobile } = content;
  const {
    title,
    disableArtworkPadding,
    textPosition,
    textPositionMobile,
    embedded,
    textBlock,
    blockId,
  } = content;

  const order = textPosition === 'Left' ? 1 : 2;

  return (
    <React.Fragment>
      <Anchor id={blockId} />
      <Wrapper
        order={order}
        disableArtworkPadding={disableArtworkPadding}
        imgSmallWebP={content.bgImageSmallWebP}
        imgLargeWebP={content.bgImageLargeWebP}
        imgSmall={content.bgImageSmall}
        imgLarge={content.bgImageLarge}
        imgMobile={content.bgImageMobile}
        bgPosition={content.bgPosition}
        backgroundColor={content.backgroundColor}
        paddingLeft={content.paddingLeft}
        paddingRight={content.paddingRight}
        paddingTop={content.paddingTop}
        paddingBottom={content.paddingBottom}
      >
        <MediaGrid
          alt=""
          order={order}
          textPositionMobile={textPositionMobile}
          src={getArtworkUrl(artworkLarge || artworkSmall)}
          dimensions={getArtworkDimensions(artworkLarge || artworkSmall)}
          srcMobile={getArtworkUrl(artworkMobile)}
          dimensionsMobile={getArtworkDimensions(artworkMobile)}
          embedded={embedded}
        >
          {get(textBlock, 'fields') && (
            <TextBlockWithIcon
              content={textBlock.fields}
              srcBlockName={`Two Columns Block - ${title}`}
            />
          )}
        </MediaGrid>
      </Wrapper>
    </React.Fragment>
  );
};

TwoColumnsBlock.propTypes = {
  content: PropTypes.object,
};

export default TwoColumnsBlock;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/columnBlock/TwoColumnsBlock.js